<template>
  <div class="page page__has-bar">
    <div class="page__bd">
      <custom-layout class="weui-cells" :view-config="customViewConfig">
        <div class="weui-cell weui-cell_select weui-cell_select-after" slot="os_sealtype">
          <div class="weui-cell__hd">
            <label for class="weui-label">{{ customLabel.os_sealtype || "印章类型" }}</label>
          </div>
          <div class="weui-cell__bd">
            <select class="weui-select" v-model="form.main.os_sealtype" placeholder="请选择">
              <option>公章</option>
              <option>合同章</option>
              <option>采购章</option>
              <option>财务章</option>
              <option>其它</option>
            </select>
          </div>
        </div>
        <div class="weui-cell" slot="os_filename">
          <div class="weui-cell__hd">
            <label for class="weui-label">{{ customLabel.os_filename || "文件名称" }}</label>
          </div>
          <div class="weui-cell__bd">
            <input class="weui-input" type="text" v-model="form.main.os_filename" placeholder="请输入文件名称" />
          </div>
        </div>
        <date-field slot="os_usetime" :label="customLabel.os_usetime || '用印时间'" v-model="form.main.os_usetime" />
        <div class="weui-cell" slot="os_filenum">
          <div class="weui-cell__hd">
            <label for class="weui-label">{{ customLabel.os_filenum || "文件份数" }}</label>
          </div>
          <div class="weui-cell__bd">
            <input class="weui-input" type="number" v-model="form.main.os_filenum" minvalue="1" maxvalue="999999" />
          </div>
        </div>
        <combo-field slot="os_filetype" :label="customLabel.os_filetype || '文件类型'" v-model="form.main.os_filetype"
          url="/api/document/filekind/getCombo" />
        <customer-field slot="os_custname" :label="customLabel.os_custname || '客户名称'" v-model="form.main.os_custname"
          @select="onSelectCustomer" />
        <vendor-field slot="os_vendname" :label="customLabel.os_vendname || '供应商名称'" v-model="form.main.os_vendname" @select="onSelectVend" />
        <div
            class="weui-cell weui-cell_select weui-cell_select-after"
            slot="os_archive"
          >
            <div class="weui-cell__hd">
              <label for class="weui-label">{{
                customLabel.os_archive || "回传要求"
              }}</label>
            </div>
            <div class="weui-cell__bd">
              <select
                class="weui-select"
                v-model="form.main.os_archive"
                placeholder="请选择"
              >
                <option>回传</option>
                <option>不回传</option>
              </select>
            </div>
          </div>
          <div
            class="weui-cell weui-cell_select weui-cell_select-after"
            slot="os_state"
          >
            <div class="weui-cell__hd">
              <label for class="weui-label">{{
                customLabel.os_state || "用印状态"
              }}</label>
            </div>
            <div class="weui-cell__bd">
              <select
                class="weui-select"
                v-model="form.main.os_state"
                placeholder="请选择"
              >
                <option>有效</option>
                <option>无效</option>
              </select>
            </div>
          </div>
        <div class="weui-cell" slot="os_remark">
          <div class="weui-cell__bd">
            <textarea class="weui-textarea" :placeholder="customLabel.os_remark || '用印事由'" rows="3"
              v-model="form.main.os_remark" maxlength="100"></textarea>
            <div class="weui-textarea-counter">
              <span>{{ form.main.os_remark ? form.main.os_remark.length : 0 }}</span>/100
            </div>
          </div>
        </div>

        <file-field v-model="form.main.os_attach" slot="os_attach" />
        <h5 slot="os_attach_col" style="border-top: 1px solid #e5e5e5; padding: 10px;">回传文件</h5>
        <file-field v-model="form.main.os_attach_col"  />
      </custom-layout>
    </div>

    <div class="footer-bar weui-dialog__ft">
      <a href="javascript:;" class="weui-dialog__btn weui-dialog__btn_primary" @click="save">提交</a>
      <a href="javascript:;" class="weui-dialog__btn weui-dialog__btn_default" @click="$router.back()">取消</a>
    </div>
  </div>
</template>

<script>
import CustomLayout from "@/components/layout/CustomLayout.vue";
import ComboField from "@/components/field/ComboField.vue";
import DateField from "@/components/field/DateField.vue";
import FileField from "@/components/field/FileField.vue";
import VendorField from "@/components/field/VendorField.vue";
import CustomerField from "@/components/field/CustomerField.vue";
import process from "@/mixins/process.js";

export default {
  components: {
    CustomLayout,
    ComboField,
    DateField,
    CustomerField,
    VendorField,
    FileField
  },
  mixins: [process],
  data() {
    return {
      baseUrl: "/api/oa/officialseal",
      codeField: "os_code",
      statusField: "os_statuscode",
      caller: "OfficialSeal",
      xtype: 'oa-officialseal-formpanel',
      form: {
        main: {
          os_sealtype: "公章",
          os_filename: null,
          os_filenum: 1,
          os_filetype: null,
          os_usetime: this.dateFormat(new Date(), "yyyy-MM-dd hh:mm:ss"),
          os_remark: null,
          os_archive: "回传",
          os_state: "有效"
        }
      }
    };
  },
  methods: {
    onSelectCustomer(selection) {
      var me = this,
        main = me.form.main;
      main.os_custid = selection.id;
      main.os_custcode = selection.cu_code;
    },
    onSelectVend(selection) {
      var me = this,
        main = me.form.main;
      main.os_vendid = selection.id;
      main.os_vendcode = selection.ve_code;
      main.os_vendname = selection.ve_name;
    },
    save() {
      var me = this,
        main = me.form.main;
      if (!main.os_filename) {
        me.$weui.topTips("请填写文件名称", 2000);
      } else if (!main.os_filenum) {
        me.$weui.topTips("请填写文件份数", 2000);
      } else if (!main.os_remark) {
        me.$weui.topTips("请填写用印事由", 2000);
      } else {
        me.p_save();
      }
    }
  }
};
</script>